import type { RenderParamType } from '@base/lib/Countdown';

export type ITimePeriod = 'days' | 'day' | 'hrs' | 'hr' | 'mins' | 'min'

export const CountdownLanguageCode = {
    notStarted: {
        days: {
            timeKey: 'day',
            langCode: 'web_shop_crowdfunding_days_togo'
        },
        day: {
            timeKey: 'day',
            langCode: 'web_shop_crowdfunding_day_togo'
        },
        hrs: {
            timeKey: 'hour',
            langCode: 'web_shop_crowdfunding_hrs_togo'
        },
        hr: {
            timeKey: 'hour',
            langCode: 'web_shop_crowdfunding_hr_togo'
        },
        mins: {
            timeKey: 'minute',
            langCode: 'web_shop_crowdfunding_mins_togo'
        },
        min: {
            timeKey: 'minute',
            langCode: 'web_shop_crowdfunding_min_togo'
        },
    },
    inProgress: {
        days: {
            timeKey: 'day',
            langCode: 'web_shop_crowdfunding_days_left'
        },
        day: {
            timeKey: 'day',
            langCode: 'web_shop_crowdfunding_day_left'
        },
        hrs: {
            timeKey: 'hour',
            langCode: 'web_shop_crowdfunding_hrs_left'
        },
        hr: {
            timeKey: 'hour',
            langCode: 'web_shop_crowdfunding_hr_left'
        },
        mins: {
            timeKey: 'minute',
            langCode: 'web_shop_crowdfunding_mins_left'
        },
        min: {
            timeKey: 'minute',
            langCode: 'web_shop_crowdfunding_min_left'
        },
    }
}

// 判断倒计时 时间段
export const checkCountdownTimePeriod = (
    o: RenderParamType,
): ITimePeriod => {

    const { day, hour, minute, second } = o

    if(+day > 1) {
        return 'days'
    } else if (+day > 0) {
        return 'day'
    } else if (+hour > 1) {
        return 'hrs'
    } else if (+hour > 0) {
        return 'hr'
    } else if (+minute > 1) {
        return 'mins'
    } else if (+minute > 0) {
        return 'min'
    }
    // 秒 显示 0 mins
    return 'mins'
}
